import React from "react";

function relative(iso: string | null): string {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  const now = Date.now();
  const deltaSec = Math.round((now - then) / 1000);
  if (deltaSec < 0) return "in the future";
  if (deltaSec < 60) return `${deltaSec}s ago`;
  if (deltaSec < 3600) return `${Math.round(deltaSec / 60)}m ago`;
  if (deltaSec < 86400) return `${Math.round(deltaSec / 3600)}h ago`;
  return `${Math.round(deltaSec / 86400)}d ago`;
}

export function Time({ iso }: { iso: string | null }) {
  if (!iso) return <span className="text-textLight">—</span>;
  const date = new Date(iso);
  return (
    <span title={date.toLocaleString()} className="tabular-nums">
      {relative(iso)}
    </span>
  );
}
